import React from 'react';
import {Button} from "react-bootstrap";

const Row = ({ affid, subid, country, cutoff, type, updateFactor }) => {
    return (
        <tr>
            <td>{affid}</td>
            <td>{subid}</td>
            <td>{country}</td>
            <td>{cutoff}</td>
            <td style={{ width: '1%', whiteSpace: "nowrap" }}>
                <Button bsStyle={'primary'} onClick={() => updateFactor(affid, subid, country, type)}>Edit Factor</Button>
            </td>
        </tr>
    );
};

export default Row;



// WEBPACK FOOTER //
// ./src/scenes/DynamicCutoffAll/components/Table/components/Row/index.js